// 3rd Party
import React from 'react';
import classNames from 'classnames';
import Dropzone, { Accept, DropzoneOptions } from 'react-dropzone';

// i18n
import { formatBytes, formatMessage } from '@/utils/i18n';

// Components
import { PillLabel } from '@/views/components/misc';

// Assets
import SingleFile from '@/images/design-system-v2/upload/singleFile.svg';
import MultipleFiles from '@/images/design-system-v2/upload/multipleFiles.svg';
import { PrimaryLink } from '../buttons';
import { extractFileExtensions } from '@/utils/file';
import { FormattedMessageV2 } from '../i18n';

export type FileUploadProps = {
  onDrop?: DropzoneOptions['onDrop'];
  accept: Accept;
  maxSize: number;
  maxFiles?: number;
};

const UploadSection: React.FC<FileUploadProps> = ({ onDrop, accept, maxSize, maxFiles }) => (
  <div className="file-upload">
    <Dropzone onDrop={onDrop} accept={accept} maxSize={maxSize} maxFiles={maxFiles} minSize={1} multiple={false} noKeyboard noClick>
      {({ getRootProps, getInputProps, isDragActive, open }) => (
        <div
          {...getRootProps()}
          className={classNames('file-upload-dropzone', {
            'is-dragging': isDragActive,
          })}
        >
          <input {...getInputProps()} />

          <img
            alt={formatMessage('UploadSection.Alt.FileUploadImage')}
            className="file-upload-image"
            src={!maxFiles || maxFiles > 1 ? MultipleFiles : SingleFile}
          />

          <div className="file-upload-title">
            <FormattedMessageV2 toLocalize="UploadSection.DragFileHere" />
            <PrimaryLink onClick={open}>
              <FormattedMessageV2 toLocalize="UploadSection.ChoseFile" />
            </PrimaryLink>
          </div>

          <div className="file-upload-subtitle">{extractFileExtensions(accept)}</div>

          <PillLabel className="pill-label-v2" text={formatMessage('UploadSection.MaxSize', { size: formatBytes(maxSize) })} />
        </div>
      )}
    </Dropzone>
  </div>
);

export default UploadSection;
